import React from "react";
import styled from "styled-components";

const BlueText = styled.span`
  && {
    font-weight: ${({ bold }) => (bold ? "700" : "600")};
    font-size: ${({ size }) => size || "inherit"};
    color: #1255CC !important;
    display: inline !important;
  }
`;
 
const GreenText = styled.span`
  && {
    font-weight: ${({ bold }) => (bold ? "700" : "600")};
    font-size: ${({ size }) => size || "inherit"};
    color: #6AA84F !important;
    display: inline !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
`;

 
const BrandWrapper = styled.span`
  && {
    white-space: nowrap !important;
    display: inline-block !important;

`;
 
/**
 * OneWayBase branded component
 * @param {boolean} bold - Make text bold (default: false)
 * @param {string} size - Font size (default: inherit)
 */
const OneWayBaseLogo = ({ bold = false, size, ...props }) => {
  return (
    <BrandWrapper {...props}>
      <BlueText bold={bold} size={size}>Oneway</BlueText><GreenText bold={bold} size={size}>Base</GreenText>
    </BrandWrapper>
  );
};

export default OneWayBaseLogo;
